import { useDispatch, useSelector } from "react-redux";
import { useProposalTypeData } from "../../../../../../hooks/proposal/use-proposal-type-data";
import HeaderRates from "./header-rates";
import NoRates from "./no-rates";
import TheadRatesAll from "./thead-rates-all";
import TbodyRatesAll from "./tbody-rates-all";
import { useProposalComputation } from "../../../../../../hooks/proposal/use-proposal-computation";
import { handleBulkFillSave } from "../../../../../../helper/rates/rates-input-helper";
import { useRateAmountChange } from "../../../../../../hooks/rates/use-rates-amount-change-66-80";
import BulkFillMonthsModal from "../bulk-fill-months-modal";
import InputFormatWarning from "../../../common/input-format-warning";
import InputFormatInfo from "../../../common/input-format-info";
import { setAmountWarning, setBulkData } from "../../../../../../features/actuarial/rates-slice";
import { RootState } from "../../../../../../api/store";

export default function Rate7680() {

    const isLoadingComputeRates = useSelector((state: RootState) =>
        Object.values(state.api.mutations ?? {}).some(
            (mutation: any) => mutation?.endpointName === 'computeRates' && mutation?.status === 'pending' )
    );

    const dispatch = useDispatch();
    const { isNoRates, isRatesIsAgeType } = useProposalTypeData();
    const { 
        isUpdateRates, 
        rates7680,  
        bulkValue, 
        bulkWarning, 
        isBulkFillOpen, 
        selectedMonths,
        amountWarning7680,
        is7680ActiveAgeBracket
    } = useProposalComputation();
    

    const { handleChangeAmount } = useRateAmountChange({
        rates: rates7680 ?? [],
        typeOfAgeRates: "gcliRates7680",
        typeOfRates: isRatesIsAgeType,
        setAmountWarning: (warning) => dispatch(setAmountWarning({ rateType: "rates7680", warning })),
        startAge: '76',
        endAge: '80',
        ageBracket: '76-80',
    });

    if (!rates7680 || rates7680.length === 0) return null;

    const ages = rates7680.map(group => group.title);
    const terms = rates7680[0]?.data || [];
    const theadNames = terms.map(item => item.acronym);
    const theadTitles = isRatesIsAgeType ? theadNames : ages

    const tableTitle = isRatesIsAgeType ? `Enrolling Age 76-80` : `Borrowers Age 76-80`
    const firstTheadTitle = isRatesIsAgeType ? `Attained Age` : `Term of Loan`


    const availableMonths = Array.from(new Set(
        rates7680.flatMap((group) => group.data
                .map((item) => item.name || item.acronym)
                .filter((name): name is string => Boolean(name))
        )
    ));


    return (
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex min-h-[42px] items-center justify-between gap-2 border-b border-gray-200 bg-[#186cb2]/10 px-3 py-2.5">
                <HeaderRates title={tableTitle} fontSize="text-xs font-semibold text-gray-700" fontWeight="" />
                <div className="flex items-center gap-2">
                    {/* {!isRatesIsAgeType && isUpdateRates && (
                        <button
                            type="button"
                            onClick={() => {
                                dispatch(setBulkData({
                                    bulkWarning: null,
                                    isBulkFillOpen: true,
                                    activeAgeBracket: "76-80",
                                }));
                            }}
                            className="rounded-md border border-[#186cb2]/30 bg-white px-2.5 py-1 text-[10px] font-semibold text-[#186cb2] transition-colors hover:bg-[#186cb2]/10"
                        >
                            Bulk Fill
                        </button>
                    )} */}
                    {isUpdateRates && (
                        <span className="rounded-md border border-[#186cb2]/20 bg-[#186cb2]/10 px-2.5 py-1 text-[10px] font-medium text-[#186cb2]">
                            Editing
                        </span>
                    )}
                </div>
            </div>
            <InputFormatInfo isShow={isUpdateRates} isNoFree={!isRatesIsAgeType}/>
            {isUpdateRates && amountWarning7680 && (
                <InputFormatWarning
                    warningMessage={amountWarning7680}
                    warningClose={() => dispatch(setAmountWarning({ rateType: "rates7680", warning: null }))}
                />
            )}
            <div className="overflow-x-auto">
                <table className="w-full min-w-max border-collapse">
                    {isNoRates ? (
                        <>
                            <NoRates/>
                        </>
                    ) : (
                        <>
                            <TheadRatesAll
                                theadTitle={theadTitles} 
                                firstTheadTitle={firstTheadTitle}
                            />
                            <TbodyRatesAll
                                isDisableInput={isLoadingComputeRates}
                                isRatesIsAgeType={isRatesIsAgeType}
                                tbody={terms} 
                                dataRates={rates7680} 
                                handleChangeAmount={handleChangeAmount} 
                            />
                        </>
                    )}
                </table>
            </div>
            {isBulkFillOpen && is7680ActiveAgeBracket && !isRatesIsAgeType && (
                <BulkFillMonthsModal
                    typeOfAgeBracket="76-80"
                    availableMonths={availableMonths}
                    bulkValue={bulkValue}
                    setBulkValue={(value) => dispatch(setBulkData({bulkValue: value}))}
                    selectedMonths={selectedMonths}
                    setSelectedMonths={(value) => dispatch(setBulkData({ selectedMonths: value }))}
                    bulkWarning={bulkWarning}
                    setBulkWarning={(value) => dispatch(setBulkData({ bulkWarning: value }))}
                    isBulkFillOpen={isBulkFillOpen}
                    setIsBulkFillOpen={(value) => dispatch(setBulkData({ isBulkFillOpen: value }))}
                    handleSaveBulk={() =>
                        handleBulkFillSave( 
                            dispatch,
                            "gcliRates7680",
                            rates7680,
                            isRatesIsAgeType,
                            (value) => dispatch(setBulkData({ isBulkFillOpen: value })),
                            (value) => dispatch(setBulkData({ bulkWarning: value })),
                            (value) => dispatch(setAmountWarning({ rateType: "rates7680", warning: value })),
                            selectedMonths,
                            (value) => dispatch(setBulkData({ selectedMonths: value })),
                            bulkValue,
                            (value) => dispatch(setBulkData({ bulkValue: value })),
                        )
                    }
                />
            )}
        </div>
    );
}